/**
 * Sentry environment loader. Uses the same `FIREBASE_ENV` as `firebase.env.js`.
 * Bundlers must inject `process.env.FIREBASE_ENV` at build time.
 *
 * - development — DSN disabled (local dev)
 * - staging — staging Sentry project
 * - production — production Sentry project
 */

import developmentConfig from './sentry.env.development.js';
import stagingConfig from './sentry.env.staging.js';
import productionConfig from './sentry.env.production.js';

// Same as firebase.env.js: no `?.` on FIREBASE_ENV so Webpack DefinePlugin inlines the value.
let env = process.env.FIREBASE_ENV || 'development';

/** @deprecated use FIREBASE_ENV=development */
if (env === 'localhost') {
  env = 'development';
}

const validEnvironments = ['development', 'staging', 'production'];
if (!validEnvironments.includes(env)) {
  throw new Error(
    `Invalid FIREBASE_ENV for Sentry: "${env}". Must be one of: ${validEnvironments.join(', ')}.`
  );
}

let envConfig;
switch (env) {
  case 'development':
    envConfig = developmentConfig;
    break;
  case 'staging':
    envConfig = stagingConfig;
    break;
  case 'production':
    envConfig = productionConfig;
    break;
  default:
    throw new Error(`Unsupported Sentry environment: ${env}`);
}

const { environment, dsn } = envConfig;

export default {
  environment,
  dsn,
};

export { environment, dsn };
